import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { LoginResponse } from '../api/authApi';
export interface AuthUser {
  accessToken: string;
  type: string;
}

interface AuthState {
  session: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

const _token = Cookies.get('access-token');

const initialState: AuthState = {
  session: _token ? { accessToken: _token, type: 'Bearer' } : null,
  isAuthenticated: !!_token,
  isLoading: false,
  error: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    login: (
      state,
      action: PayloadAction<LoginResponse | { accessToken: string; type: string }>
    ) => {
      Cookies.set('access-token', action.payload.accessToken!);
      state.session = {
        accessToken: action?.payload?.accessToken!,
        type: action?.payload?.type,
      };
      state.isAuthenticated = true;
      state.error = null;
      state.isLoading = false;
      localStorage.setItem('hasSeenWelcomePopup', 'false');
    },
    logout: (state) => {
      state.session = null;
      state.isAuthenticated = false;
      state.error = null;
      Cookies.remove('access-token');
    },
  },
});

export const { login, logout, setLoading, setError } = authSlice.actions;
export default authSlice.reducer;
